import { render, staticRenderFns } from "./NavigationButtons.vue?vue&type=template&id=3f6558e1&"
import script from "./NavigationButtons.vue?vue&type=script&lang=ts&"
export * from "./NavigationButtons.vue?vue&type=script&lang=ts&"
import style0 from "./NavigationButtons.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports